import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20artistic%20illustration%20of%20dynamic%20comic%20panels%20with%20warm%20vibrant%20colors%2C%20action%20scenes%20mixed%20with%20romantic%20moments%2C%20abstract%20comic%20page%20layout%20with%20speech%20bubbles%2C%20artistic%20watercolor%20style%20background%2C%20dramatic%20composition%2C%20digital%20art%20aesthetic&width=1600&height=900&seq=hanman-hero-01&orientation=landscape"
        alt="韩漫网 - 在线漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="韩漫网 在线漫画 韩国漫画"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="animate-fade-in">
            <span className="inline-block px-4 py-2 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6">
              每日更新 · 免费阅读
            </span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-6 leading-tight animate-slide-up">
            发现最<strong className="text-primary-300">好看的</strong>
            <br className="hidden sm:block" />
            韩国漫画
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed animate-slide-up">
            韩漫网为您精选海量高质量韩国漫画，热血、爱情、冒险、奇幻、搞笑、悬疑，多样题材应有尽有。<br className="hidden md:block" />
            资源齐全，加载快速，随时随地免费在线看漫画。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-slide-up">
            <Link
              to="/category/rexue"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              开始阅读
              <span className="ml-2 w-4 h-4 inline-flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold rounded-full backdrop-blur-sm transition-all duration-300 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}